module.exports = __webpack_public_path__ + "static/media/service.933689d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/service.png
// module id = 232
// module chunks = 0